import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const UnreadMail = ({
  height = 16,
  width = 16,
  color = colors.secondaryText,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 16 16"
    style={{ strokeWidth: 0 }}
    {...props}
  >
    <g fillRule="evenodd" clipRule="evenodd" fill={getColor(color, isColorInherited)}>
      <path d="M2.75 4.39581C2.61193 4.39581 2.5 4.50774 2.5 4.64581V11.6458C2.5 11.7839 2.61193 11.8958 2.75 11.8958H13.25C13.3881 11.8958 13.5 11.7839 13.5 11.6458V4.64581C13.5 4.50774 13.3881 4.39581 13.25 4.39581H2.75ZM1.25 4.64581C1.25 3.81739 1.92157 3.14581 2.75 3.14581H13.25C14.0784 3.14581 14.75 3.81739 14.75 4.64581V11.6458C14.75 12.4742 14.0784 13.1458 13.25 13.1458H2.75C1.92157 13.1458 1.25 12.4742 1.25 11.6458V4.64581Z" />
      <path d="M1.57734 3.7106C1.78779 3.43699 2.18019 3.38579 2.4538 3.59624L7.20446 7.25024C7.43253 7.42569 7.71225 7.52085 8 7.52085C8.28775 7.52085 8.56743 7.42572 8.7955 7.25027L13.5462 3.59624C13.8198 3.38579 14.2122 3.43699 14.4227 3.7106C14.6331 3.98421 14.5819 4.37661 14.3083 4.58705L9.55767 8.24103C9.11108 8.58458 8.56344 8.77085 8 8.77085C7.43656 8.77085 6.88892 8.58458 6.44233 8.24103L1.6917 4.58705C1.4181 4.37661 1.3669 3.98421 1.57734 3.7106Z" />
    </g>
  </SvgIcon>
);
